// ── Which rows does the editor preview against? ──────────────────────────
// Never reruns anything: only rows the client already holds.
//
//   Source = self (this step's own input)
//     previous step has rows in the last /preview run (runMap)  -> 'server'
//     first step / no run yet: the uploaded data (uploadedRows) -> 'browser'
//   Source = a named sheet or uploaded file (sheets / secondaryDatasets)
//                                                                -> 'browser'
//   Source = an earlier step's published output_name (runMap)    -> 'server'
//
// 'browser' rows come from the client's own parse, so dates and booleans may
// differ from a real run — the editor says so.

import { buildSourceEntries, findSourceEntry } from '../../../data.js';

export const ROW_CAP = 200;
export const BROWSER_PARSE_NOTE = 'Dates and booleans may look different in a real run (a date can arrive as an Excel serial number: fromExcelSerial(num(row.col)) converts it).';

export function resolveEditorRows({ source, orderedSteps = [], stepId, runMap, sheets, secondaryDatasets, uploadedRows, steps, cap = ROW_CAP }) {
  const take = (rows, origin) => {
    const list = Array.isArray(rows) ? rows : [];
    if (!list.length) return { rows: [], origin: 'none', note: null };
    return { rows: list.slice(0, cap), origin, note: origin === 'browser' ? BROWSER_PARSE_NOTE : null };
  };

  if (!source || source === '__self__') {
    const idx = orderedSteps.findIndex(s => s.id === stepId);
    const prev = idx > 0 ? orderedSteps[idx - 1] : null;
    const serverRows = prev ? runMap?.get?.(prev.id)?.rows : null;
    if (Array.isArray(serverRows) && serverRows.length) return take(serverRows, 'server');
    return take(uploadedRows, 'browser');
  }

  const entry = findSourceEntry(buildSourceEntries({ sheets, secondaryDatasets, steps }), source);
  if (!entry) return { rows: [], origin: 'none', note: null };
  if (entry.kind === 'sheet') return take(sheets?.get?.(entry.name)?.rows, 'browser');
  if (entry.kind === 'file') return take(secondaryDatasets?.get?.(entry.name)?.rows, 'browser');
  return take(runMap?.get?.(entry.step.id)?.rows, 'server');
}
